import Vue from 'vue'
import UIUtils from '../utils/UIUtils'

// handlersMap[context][keyCode].handlers = []
const handlersMap = {}

// key: code
const GRIFFIN_KEYS_MAP = {
    a: 'KeyA',
    d: 'KeyD',
    w: 'KeyW',
    s: 'KeyS',
    e: 'KeyE',
    q: 'KeyQ',
    ' ': 'Space'
}

const getKeyCodeFromEvent = event => {
    const { code, key } = event

    return code || GRIFFIN_KEYS_MAP[key]
}

export default {
    subscribeTo(context, keyCode, handler, once, ctrl = false, alt = false, shift = false) {
        if (!handlersMap[context]) {
            handlersMap[context] = {}
        }

        if (!handlersMap[context][keyCode]) {
            handlersMap[context][keyCode] = {
                handlers: [],
                ctrl: ctrl,
                alt: alt,
                shift: shift
            }
        }

        if (!once || handlersMap[context][keyCode].handlers.length === 0) {
            handlersMap[context][keyCode].handlers.push(handler)
        }
    },

    unsubscribeAll(context, keyCode) {
        if (handlersMap[context]) {
            delete handlersMap[context][keyCode]
        }
    },

    init() {
        window.addEventListener('keydown', event => {
            const timelapse = Vue.$store.state.timelapse

            // TODO: change to single flag videoControlsActive or smth like this
            if (
                !UIUtils.isModalOpen() &&
                !timelapse.noteIsEdited &&
                !timelapse.shareDialogOpened &&
                !timelapse.shareToPatientDialogOpened
            ) {
                const keyCode = getKeyCodeFromEvent(event)

                for (const contextKeyHandlers of Object.values(handlersMap)) {
                    const keyHandlers = contextKeyHandlers[keyCode]

                    if (
                        keyHandlers &&
                        (!keyHandlers.ctrl || (keyHandlers.ctrl && event.ctrlKey)) &&
                        (!keyHandlers.alt || (keyHandlers.alt && event.altKey)) &&
                        (!keyHandlers.shift || (keyHandlers.shift && event.shiftKey))
                    ) {
                        for (const handler of keyHandlers.handlers) {
                            event.preventDefault()
                            event.stopImmediatePropagation()

                            handler()
                        }
                    }
                }
            }
        })
    }
}
